import api from '../../api/api'
export default {
    namespaced: true,
    state: {
        questions: [],
        current: 0,
        life: 4,
        answers: [],
        selectedPhotographerId: null,
        score: 0,
        scoreStep: 3,
        topScores: null,
        userScoreData: null,
        price: null,
        finished: false,
    },
    getters: {
        next(state) {
            const next = state.current+1;
            if( next in state.questions)
                return next;
            return false;
        },
        question(state) {
            if(state.current in state.questions)
                return state.questions[state.current];

            return null;
        },
        answer(state, getters){
            return parseInt(getters.question['token'].substring(10, 15))  - 15;
        },
        image1(state){
            if(state.current % 2 === 0)
                return 'https://shootshot.com/api/game2-image/?DefdwsdE=' + state.questions[state.current]['image'];
            else
                return 'https://shootshot.com/api/game2-image/?DefdwsdE=' + state.questions[state.current+1]['image'];
        },
        image2(state){
            if(state.current % 2 === 1)
                return 'https://shootshot.com/api/game2-image/?DefdwsdE=' + state.questions[state.current]['image'];
            else
                return 'https://shootshot.com/api/game2-image/?DefdwsdE=' + state.questions[state.current+1]['image'];
        },
        showImage1(state){
            return state.current % 2 === 0;
        },
        showImage2(state){
            return state.current % 2 === 1;
        },
        imageQueue(state){

            let images = [];

            const imagePrefix = 'https://shootshot.com/api/game2-image/?DefdwsdE=';

            if( state.current+1 in  state.questions)
                images.push(imagePrefix+state.questions[state.current+1]['image']);

            if( state.current+2 in  state.questions)
                images.push(imagePrefix+state.questions[state.current+2]['image']);

            if( state.current+3 in  state.questions)
                images.push(imagePrefix+state.questions[state.current+3]['image']);

            if( state.current+4 in  state.questions)
                images.push(imagePrefix+state.questions[state.current+4]['image']);

            if( state.current+5 in  state.questions)
                images.push(imagePrefix+state.questions[state.current+5]['image']);

            return images;
        },
        answerIsCorrect(state, getters){
            return state.selectedPhotographerId
                ? state.selectedPhotographerId === getters.answer
                : null;
        },
        buttonsDisabled(state){
            return state.selectedPhotographerId !== null;
        }
    },
    mutations: {
        RESET_GAME(state) {
            state.questions = [];
            state.current = 0;
            state.life = 4;
            state.answers = [];
            state.selectedPhotographerId = null;
            state.score = 0;
            state.scoreStep = 3;
            state.topScores = null;
            state.userScoreData = null;
            state.finished = false;
        },
        ADD_TO_QUESTIONS(state, payload) {
            state.questions = [...state.questions, ...payload];
        },
        ADD_ANSWER(state, {image, selected}){
            state.answers.push({image , selected});
        },
        SET_SELECTED_PHOTOGRAPHER_ID(state, payload){
            if(payload === null)
                state.selectedPhotographerId = null;
            else
                state.selectedPhotographerId = parseInt(payload);
        },
        DEATH(state){
            state.life--;
        },
        ADD_SCORE(state){
            state.score += state.scoreStep;
        },
        SET_FINISHED_DATA(state, {topScores, userScoreData, price}){
            state.topScores = topScores;
            state.userScoreData = userScoreData;
            state.price = price;
        },
        SET_FINISHED(state){
            state.finished = true;
        },
    },
    actions: {
        nextQuestion({state, commit, dispatch, getters}){

            if(state.life < 1){
                dispatch('gameFinished');
                return;
            }
            if(state.current > state.questions.length - 5 || !getters.next)
                dispatch('loadQuestions');
            state.current = getters.next;
            commit('SET_SELECTED_PHOTOGRAPHER_ID', null);
        },
        async loadQuestions({commit}){
            const newQuestions = await api.call('game2-questions');
            commit('ADD_TO_QUESTIONS', newQuestions);
        },
        addAnswer({commit}, {image, selected}){
            commit('ADD_ANSWER', {image, selected});
        },
        setSelectedPhotographerId({commit}, payload){
            commit('SET_SELECTED_PHOTOGRAPHER_ID', payload);
        },
        async gameFinished({commit, state}){
            commit('SET_FINISHED');
            const response = await api.call('game2-finish', {
                answers: JSON.stringify(state.answers),
            });
            commit('SET_FINISHED_DATA', {
                topScores: response.topScores,
                userScoreData: response.userScoreData,
                price: response.price
            });
        },
        checkAnswer({commit,getters}, payload){

            const selectedPhotographerId = getters.question.options[payload].id;
            commit('SET_SELECTED_PHOTOGRAPHER_ID', selectedPhotographerId);

            commit('ADD_ANSWER', {
                image: getters.question.image,
                selected : selectedPhotographerId
            });

            if(!getters.answerIsCorrect){
                commit('DEATH');
            }else{
                commit('ADD_SCORE');
            }
        },
        resetGame({commit}){
            commit('RESET_GAME');
        },
    },
};